"use client";

import { useEffect, useRef } from "react";

const ToolImage = ({ tool }) => {
  const imgRef = useRef(null);
  
  useEffect(() => {
    const updateSize = () => {
      if (imgRef.current) {
        if (window.innerWidth >= 768) {
          imgRef.current.style.width = `${tool.mdWidth}px`;
          imgRef.current.style.height = `${tool.mdHeight}px`;
        } else {
          imgRef.current.style.width = `${tool.width}px`;
          imgRef.current.style.height = `${tool.height}px`;
        }
      }
    };
    
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, [tool.width, tool.height, tool.mdWidth, tool.mdHeight]);
  
  return (
    <img
      ref={imgRef}
      src={tool.src}
      alt={tool.alt}
      className="object-contain"
      style={{
        width: `${tool.width}px`,
        height: `${tool.height}px`,
      }}
    />
  );
};

const ToolsSection = () => {
  const tools = [
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t1.webp", alt: "Tool 1", width: "84", height: "84", mdWidth: "124", mdHeight: "124" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t2.webp", alt: "Tool 2", width: "84", height: "84", mdWidth: "124", mdHeight: "124" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t3.webp", alt: "Tool 3", width: "80", height: "20", mdWidth: "124", mdHeight: "124" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t4.webp", alt: "Tool 4", width: "78", height: "28", mdWidth: "124", mdHeight: "124" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t5.webp", alt: "Tool 5", width: "74", height: "24", mdWidth: "74", mdHeight: "74" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t6.webp", alt: "Tool 6", width: "94", height: "24", mdWidth: "140", mdHeight: "140" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t7.webp", alt: "Tool 7", width: "100", height: "20", mdWidth: "124", mdHeight: "124" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t8.webp", alt: "Tool 8", width: "88", height: "28", mdWidth: "104", mdHeight: "104" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t9.webp", alt: "Tool 9", width: "88", height: "28", mdWidth: "124", mdHeight: "124" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t10.webp", alt: "Tool 10", width: "84", height: "24", mdWidth: "134", mdHeight: "134" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t11.webp", alt: "Tool 11", width: "94", height: "24", mdWidth: "114", mdHeight: "114" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t12.webp", alt: "Tool 12", width: "94", height: "24", mdWidth: "144", mdHeight: "144" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t13.webp", alt: "Tool 13", width: "90", height: "20", mdWidth: "124", mdHeight: "124" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t14.webp", alt: "Tool 14", width: "82", height: "32", mdWidth: "114", mdHeight: "114" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t15.webp", alt: "Tool 15", width: "84", height: "24", mdWidth: "134", mdHeight: "134" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t16.webp", alt: "Tool 16", width: "32", height: "32", mdWidth: "44", mdHeight: "44" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t17.webp", alt: "Tool 17", width: "32", height: "32", mdWidth: "44", mdHeight: "44" },
    { src: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/t18.webp", alt: "Tool 18", width: "24", height: "24", mdWidth: "44", mdHeight: "44" },
  ];

  return (
    <section className="w-full py-6 md:py-12">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 text-left">
          <p className="text-[#0A0A0A] text-sm md:text-base font-normal uppercase mb-2">
            SKILL STACK
          </p>
          <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-3 w-full md:w-[80%]">
            Tools you will learn
          </h2>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-3 gap-4 md:gap-6 md:grid-cols-6">
        {tools.map((tool, index) => (
          <div
            key={index}
            className="flex items-center justify-center border border-gray-300 h-14 bg-white md:p-3 p-1 rounded-lg"
          >
            <ToolImage tool={tool} />
          </div>
        ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;
